import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import logo from '../../../../assets/images/logo-round.svg';
import { useTheme } from '@emotion/react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import DocumentViewer from '../../../../components/DocumentViewer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const screeningStatus = {
  pending: '#BA9B1D1A',
  approved: '#00A63226',
  rejected: '#C220201A',
  inprogress: '#006DFF1A',
  pendingColor: '#BA9B1D',
  approvedColor: '#00A632',
  rejectedColor: '#C22020',
  inprogressColor: '#006DFF',
};

export default function Details({ setOpenAccept, setOpenReject, details }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const {t} = useTranslation()

  return (
    <Stack
      className="pt-[24px] px-[16px] flex-overflow"
      flex={1}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          flex={0.6}
        >
          {details?.companyLogo && (
            <img
              src={details?.companyLogo}
              style={{ width: '48px', height: '48px', marginRight: '16px' }}
            ></img>
          )}

          <Stack>
            <Typography
              className="fw-regular ff-Roboto fs-12 !capitalize"
              color={text}
            >
              {t('Client')}
            </Typography>
            <Typography
              className="fw-medium ff-Roboto fs-14"
              color={text}
            >
              {details?.companyName || '-'}
            </Typography>
          </Stack>
        </Stack>

        <Stack flex={0.4}>
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {t('Status')}
          </Typography>
          <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{ color: screeningStatus[`${details?.screeningStatus}Color`] }}
          >
            {details?.screeningStatus === 'approved' && <CheckCircleIcon sx={{ width: '12px', marginRight: '8px' }} />}
            <Typography
              className="fw-medium ff-Roboto fs-12 capitalize"
              color={screeningStatus[`${details?.screeningStatus}Color`]}
            >
              {details?.screeningStatus}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        direction={'row'}
        className="!mb-[16px] mt-[16px]"
      >
        <Stack flex={0.6}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Display name')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium capitalize"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.displayName || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="!mb-[16px]"
      >
        <Stack flex={0.6}>
          <Typography
            className="fs-12 ff-Roboto fw-regular "
            color={text}
          >
            {t('Legal entity type')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium capitalize"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.entityType || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.4}>
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={text}
          >
            {t('Client type')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium capitalize"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.companyType || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        className="!mb-[16px]"
      >
        <Stack flex={0.6}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Address')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.regAddress || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.4}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Website')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.companyWebsite || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: '#14285A1A', height: '1px' }}
        className="!my-[16px]"
      />
      <Stack
        direction={'row'}
        className="!mb-[16px]"
      >
        <Stack flex={0.6}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Name')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium  capitalize"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.name || '-'}
          </Typography>
        </Stack>
        {/* <Stack flex={0.4}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            Last Name
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium  capitalize"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.name || '-'}
          </Typography>
        </Stack> */}
      </Stack>
      <Stack
        direction={'row'}
        className="!mb-[16px]"
      >
        <Stack flex={0.6}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Mail')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.email || '-'}
          </Typography>
        </Stack>
        <Stack flex={0.4}>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={text}
          >
            {t('Phone')}
          </Typography>
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
            style={{ maxWidth: '225px' }}
          >
            {details?.phoneCode || '-'} {details?.phoneNumber || '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: '#14285A1A', height: '1px' }}
        className="!my-[16px]"
      />
      {details?.documents?.filter(res => res.attachment).length > 0 && (
        <Stack>
          <Typography
            className="fs-12 ff-Roboto fw-regular !mb-[8px]"
            color={text}
          >
            {t('Document')}
          </Typography>
          <Stack
            direction={'row'}
            alignItems={'center'}
            className='!mb-[16px]'
          >
            {details?.documents?.filter(res => res.attachment).map((item, index) => (
              <DocumentViewer data={item} />
            ))}
          </Stack>
        </Stack>
      )}

      <Stack flexGrow={1} />
      {/* <Stack
        direction="row"
        style={{ backgroundColor: '#FFFFFF', zIndex: 1, alignItems: 'center' }}
      >
        <Button
          sx={[
            dialogButtonCancel,
            {
              color: theme.palette.primary.main,
              '&:hover': {},
            },
          ]}
          style={{ width: '78px', height: '40px' }}
          onClick={() => {
            setOpenReject();
          }}
        >
          <Typography
            color={theme.palette.primary.main}
            className="fs-14 ff-Roboto fw-medium"
          >
            REJECT
          </Typography>
        </Button>
        <Button
          sx={[
            dialogButtonCancel,
            {
              color: theme.palette.primary.main,
              '&:hover': {},
            },
          ]}
          style={{ width: '78px', height: '40px' }}
          onClick={() => {
            setOpenAccept();
          }}
        >
          <Typography
            color={theme.palette.primary.main}
            className="fs-14 ff-Roboto fw-medium "
          >
            APPROVE
          </Typography>
        </Button>
      </Stack> */}
    </Stack>
  );
}
